export const VISIT_SUPPORT_LINK = "https://support.beyondidentity.com/";
